// src/components/common/LanguageSwitcher.js
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { analyticsEvents } from '../../utils/analyticsEvents';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  // Initialize document direction on mount
  useEffect(() => {
    const lng = i18n.language || localStorage.getItem('language') || 'ar';
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
  }, [i18n.language]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
    // Update document direction for RTL
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
    analyticsEvents.languageChange(lng);
  };

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => changeLanguage('ar')}
        className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${
          i18n.language === 'ar'
            ? 'bg-shayek-primary dark:bg-shayek-primary-600 text-white'
            : 'bg-shayek-light-200 dark:bg-shayek-dark-200 text-shayek-light-700 dark:text-shayek-dark-700 hover:bg-shayek-light-300 dark:hover:bg-shayek-dark-300'
        }`}
      >
        العربية
      </button>
      <button
        onClick={() => changeLanguage('en')}
        className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${
          i18n.language === 'en'
            ? 'bg-shayek-primary dark:bg-shayek-primary-600 text-white'
            : 'bg-shayek-light-200 dark:bg-shayek-dark-200 text-shayek-light-700 dark:text-shayek-dark-700 hover:bg-shayek-light-300 dark:hover:bg-shayek-dark-300'
        }`}
      >
        English
      </button>
    </div>
  );
};

export default LanguageSwitcher;

